/**
 * Utilidades para manejar cookies en el navegador
 */

/**
 * Establece una cookie con un valor dado
 * @param name Nombre de la cookie
 * @param value Valor de la cookie
 * @param days Días hasta que expire (por defecto 365)
 */
export const setCookie = (name: string, value: string, days: number = 365): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

/**
 * Obtiene el valor de una cookie
 * @param name Nombre de la cookie
 * @returns Valor de la cookie o null si no existe
 */
export const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * Elimina una cookie
 * @param name Nombre de la cookie
 */
export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};




